/**
 * Allows a method to ommit the last 'callbacks' parameter and then the method
 * will instead return a promise that resolves on success. NOTE: There is
 * no failure callback so on error the promise will never resolve.
 * @param {function} innerFunc
 * @returns {function}
 */
export function promisify(innerFunc) {
  return function(...args) {
    var lastArg = args[args.length - 1]
    if (
      typeof lastArg === 'object' &&
      'onSuccess' in lastArg &&
      typeof lastArg['onSuccess'] === 'function'
    ) {
      return innerFunc(...args)
    }
    var self = this
    return new Promise(function(resolve) {
      args.push({ onSuccess: resolve })
      innerFunc.apply(self, args)
    })
  }
}



// WEBPACK FOOTER //
// ./src/Utils/Actions/index.js